import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";
import { apiPageLimit } from "../../../../constants/common";

const NON_REL_LOG_HOUR = `/log-time`;
const NON_REAL_REMAINING_HOUR = `/log-time/remaining/hours`;

export const getNonRealLogHourList = createAsyncThunk(
  "getNonRealLogHourList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit, search = "", participation_level = "" } = values;
      const response = await http.get(`${NON_REL_LOG_HOUR}?page=${page}&limit=${limit}&search=${search}&participation_level=${participation_level}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const archiveNonRealLogHour = createAsyncThunk(
  "archiveNonRealLogHour",
  async ({ uuid, archieve }: { uuid: any, archieve: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${NON_REL_LOG_HOUR}/${uuid}`, { archieve });
      toast.success(response?.data?.message || "Activity archived Successfully.");
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to archive activity");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getNonRealLogHourDetails = createAsyncThunk(
  "getNonRealLogHourDetails",
  async ({ uuid }: { uuid: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${NON_REL_LOG_HOUR}/${uuid}`);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to get mileage details");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const updateNonRealLogHour = createAsyncThunk(
  "updateNonRealLogHour",
  async ({ uuid, values }: { uuid: any, values: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${NON_REL_LOG_HOUR}/${uuid}`, values);
      toast.success(response?.data?.message || "Log hour updated Successfully.");
      dispatch(getNonRealLogHourList({}));
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to update log hour");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const addNonRealLogHour = createAsyncThunk(
  "addNonRealLogHour",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${NON_REL_LOG_HOUR}`, values);
      toast.success(response?.data?.message || "Log hour added Successfully.");
      dispatch(getNonRealLogHourList({}));
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to add log hour");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteNonRealLogHourDocument = createAsyncThunk(
  "deleteNonRealLogHourDocument",
  async ({ uuid, logHoureId }: { uuid: string, logHoureId: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.delete(`${NON_REL_LOG_HOUR}/${logHoureId}/image/${uuid}`);
      toast.success(response?.data?.message);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to delete document");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getNonRealRemainingLogHour = createAsyncThunk(
  "getNonRealRemainingLogHour",
  async ({ date }: { date: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${NON_REAL_REMAINING_HOUR}?date=${date}`);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to get remaining log hour.");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);